import api from '../../api';
import translate from '../../core/tools/translate';
import environment from '../../environment';

class HideAction {
    constructor({ feature, layer, currentMap, name }) {
        return {
            check: () => false,
            layer,
            map: currentMap,
            icon: 'icon_bubble_hide',
            title: translate('Action.Hide'),
            click() {
                api.general.log.action(environment._getContextEnum(name), 'Esconder', JSON.stringify(feature.properties));
                $(`#button-${name.toLowerCase()}-hideStore-${feature.properties.Id}`).trigger('click');
            }
        };
    }
}

export default HideAction;



// WEBPACK FOOTER //
// ./src/scripts/layers/HaloLayer/HideAction.js